module.exports = __webpack_public_path__ + "img/coin4.6484e137.png";